import { useTranslation } from "react-i18next";
import {
	ThemeFontSizeVariable,
	ThemeFontVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { Button } from "@caspeco/casper-ui-library.components.button";
import { Text } from "@caspeco/casper-ui-library.components.text";

interface IGoToCheckoutButton {
	isDisabled: boolean;
	onClick: () => void;
}

export default function GoToCheckoutButton({ isDisabled, onClick }: IGoToCheckoutButton) {
	const { t } = useTranslation();
	return (
		<Button
			id="goToCheckout"
			type="button"
			variant="primary"
			w="100%"
			isDisabled={isDisabled}
			onClick={onClick}
			size="lg"
			display="flex"
			justifyContent="center"
			gap={ThemeSpaceVariable.XSmall}
		>
			<Text
				fontWeight="medium"
				fontSize={ThemeFontSizeVariable.Large}
				fontFamily={ThemeFontVariable.SubHeader}
			>
				{t("purchase_go_to_checkout")}
			</Text>
		</Button>
	);
}
